export default __webpack_public_path__ + "static/fall34-945fedb20a93608523186b74d7d970f7.webp";